import { render } from "./listaFinalizadas.vue?vue&type=template&id=70690c37"
import script from "./listaFinalizadas.vue?vue&type=script&lang=js"
export * from "./listaFinalizadas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__